import { Box, Typography } from '@mui/material'
import { Suspense } from 'react'
import HomeHeroImage from '@images/home-hero.jpg'
import LogoUnicoSkill from '@images/logo-unico-skill.svg'

import { i18nTranslationHelper } from '@/i18n'
import { Outlet } from 'react-router'
import Spinner from '../spinner/spinner'
import LinkButton from '../button/link-button'
import { settings } from '@/main/config/settings'

const t = {
  page: i18nTranslationHelper.getTPage
}

const BOX_MAIN_STYLES = {
  backgroundColor: '#FFF'
}

const BOX_LEFT_COLUMN_STYLES = {
  display: 'flex',
  width: { xs: '100%', md: '50%' },
  p: { xs: 3, sm: 6 },
  pt: { xs: 6, sm: 15 },
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  minHeight: '100vh'
}

const BOX_RIGHT_COLUMN_STYLES = {
  position: 'fixed',
  right: 0,
  top: 0,
  width: '50%',
  height: '100vh',
  p: 6,
  display: { xs: 'none', md: 'flex' },
  flexDirection: 'column'
}

const BOX_CONTENT_FORM_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '400px'
}

const BOX_WELCOME_STYLES = {
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 2
}

const BOX_TERMS_STYLES = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  fontSize: '14px',
  lineHeight: '20px',
  mt: 4
}

const BOX_TERMS_LINKS_STYLES = {
  fontSize: 'inherit',
  fontWeight: '400',
  mx: 0.5,
  lineHeight: 'inherit'
}

const BOX_HERO_IMAGE_STYLES = {
  height: '100%',
  backgroundImage: `url(${HomeHeroImage})`,
  flex: 1,
  width: '100%',
  backgroundColor: '#F7FAFF',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  position: 'relative',
  borderRadius: 4
}

const AuthLayout = () => {
  return (
    <Box component="main" sx={BOX_MAIN_STYLES}>
      <Box sx={BOX_LEFT_COLUMN_STYLES}>
        <Box sx={BOX_CONTENT_FORM_STYLES}>
          <Box sx={BOX_WELCOME_STYLES}>
            <Box
              component="img"
              src={LogoUnicoSkill}
              alt="Skill Logo"
              sx={{
                height: 23,
                width: 'auto'
              }}
            />

            <Typography
              variant="subtitle1"
              color="grey.500"
              fontSize={16}
              dangerouslySetInnerHTML={{ __html: t.page('login.hero') }}
            />
          </Box>

          <Suspense fallback={<Spinner fullScreen />}>
            <Box sx={{ width: '100%', mt: 7 }}>
              <Outlet />
            </Box>
          </Suspense>

          <Box sx={BOX_TERMS_STYLES}>
            <Typography fontSize="inherit" lineHeight="inherit">
              {t.page(`firstAccess.footer.text`)}
            </Typography>

            <LinkButton
              href={settings.SKILL_TERMS_OF_USE_URL}
              cta={t.page(`firstAccess.footer.termsOfUse`)}
              sx={BOX_TERMS_LINKS_STYLES}
              target="_blank"
              rel="noopener noreferrer"
            />

            <Typography fontSize="inherit" lineHeight="inherit">
              {t.page(`firstAccess.footer.and`)}
            </Typography>

            <LinkButton
              href={settings.SKILL_PRIVACY_POLICY_URL}
              cta={t.page(`firstAccess.footer.privacyPolicy`)}
              sx={BOX_TERMS_LINKS_STYLES}
              target="_blank"
              rel="noopener noreferrer"
            />

            <Typography fontSize="inherit" lineHeight="inherit">
              {t.page(`firstAccess.footer.end`)}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={BOX_RIGHT_COLUMN_STYLES}>
        <Box sx={BOX_HERO_IMAGE_STYLES} />
      </Box>
    </Box>
  )
}

export default AuthLayout
